import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';
import { images } from '@/data/mock';


const Footer = () => {
  const location = useLocation();

  // Don't render footer on climaone page or admin routes
  if (location.pathname === '/climaone' || location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <footer className="bg-[#01298a] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and Description */}
          <div className="space-y-4">
            <img
              src={images.logoWhite}
              alt="ReCircle Foundation"
              className="h-20 w-auto"
            />
            <p className="text-white/80 text-sm">
              ReCircle Foundation is a Section 8 non-profit and the impact arm of <Link to="https://www.recircle.in" target="_blank" rel="noopener noreferrer" className="hover:text-brand-yellow transition-colors">ReCircle</Link>. Through partnerships with businesses, communities, and institutions, we drive ethical, inclusive, and traceable circular systems through on-ground interventions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-brand-yellow transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-brand-yellow transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/focus-areas" className="text-white/80 hover:text-brand-yellow transition-colors">
                  Focus Areas
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/80 hover:text-brand-yellow transition-colors">
                  Knowledge Centre
                </Link>
              </li>
              <li>
                <Link to="/impact" className="text-white/80 hover:text-brand-yellow transition-colors">
                  Impact
                </Link>
              </li>
              <li>
                <Link to="/get-involved" className="text-white/80 hover:text-brand-yellow transition-colors">
                  Get Involved
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Connect With Us</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-white/80">
                <img
                  src={images.footerIcons.Email}
                  width={18}
                  height={18}
                  className="inline-block text-brand-yellow"
                />
                <a
                  href="mailto:info@recirclefoundation.org?subject=Inquiry%20from%20Website"
                  className="hover:text-brand-yellow transition-colors duration-200"
                >
                  info@recirclefoundation.org
                </a>
              </li>
              <li className="flex items-center space-x-3 text-white/80">
                <img
                  src={images.footerIcons.Call}
                  width={18}
                  height={18}
                  className="inline-block text-brand-yellow"
                />
                <a
                  href="tel:+919004240004"
                  className="hover:text-brand-yellow transition-colors duration-200"
                >
                  +91 90042 40004
                </a>
              </li>
              <li className="flex items-start space-x-3 text-white/80">
                <img
                  src={images.footerIcons.Location}
                  width={18}
                  height={18}
                  className="inline-block text-brand-yellow"
                />
                <a
                  href="https://maps.app.goo.gl/4Zad9SAiySSutgk26"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-brand-yellow transition-colors duration-200"
                >
                  Mumbai, India
                </a>
              </li>
            </ul>
            <div className="flex space-x-3 mt-6">
              <a
                href="https://www.linkedin.com/showcase/recricle-foundation/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 hover:text-brand-yellow transition-colors"
                aria-label="LinkedIn"
              >
                <img
                  src={images.footerIcons.LinkedIn}
                  width={20}
                  height={20}
                  className="inline-block text-brand-yellow h-full pb-1"
                />              </a>
              <a
                href="https://www.instagram.com/recirclefoundation/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 hover:text-brand-yellow transition-colors"
                aria-label="Instagram"
              >
                <img
                  src={images.footerIcons.Instagram}
                  width={20}
                  height={20}
                  className="inline-block text-brand-yellow"
                />              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/80 text-sm">
            © {new Date().getFullYear()} ReCircle Foundation (non-profit arm of{" "}
            <a
              href="https://recircle.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-yellow transition-colors"
            >
              ReCircle
            </a>
            ). All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy-policy" className="text-white/80 hover:text-brand-yellow text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-white/80 hover:text-brand-yellow text-sm transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
